import { colors } from '@theme/colors';
import styled from 'styled-components';

interface ButtonProps {
  label: string;
  color?: string;
  onAction: () => any;
}

const ButtonStyle = styled.button`
  background-color: ${({ color }) => color};
  width: 164px;
  height: 40px;
  color: white;
  border-radius: 20px;
  gap: 4px;

  font-size: 14px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  border-color: transparent;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ButtonComponent = ({
  label,
  color = colors.red_peya,
  onAction,
}: ButtonProps) => (
  <Container>
    <ButtonStyle
      color={color}
      onClick={onAction}
      data-testid="button-component"
    >
      {label}
    </ButtonStyle>
  </Container>
);
